import { render, staticRenderFns } from "./MessCard.vue?vue&type=template&id=fd8aae38&scoped=true&"
import script from "./MessCard.vue?vue&type=script&lang=js&"
export * from "./MessCard.vue?vue&type=script&lang=js&"
import style0 from "./MessCard.vue?vue&type=style&index=0&id=fd8aae38&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8aae38",
  null
  
)

export default component.exports